import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div style={{ maxWidth: 960, margin: '32px auto', padding: '0 16px', fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif', lineHeight: 1.65 }}>
      <h1 style={{ marginBottom: 12 }}>Privacy Notice</h1>
      <p style={{ color: '#4b5563' }}>This explains how LoConvo collects, uses, and shares information. It applies to all users, including Google/Microsoft sign-in.</p>

      <h3>What we collect</h3>
      <ul style={{ color: '#374151', paddingLeft: 20 }}>
        <li>Account: email, username, auth identifiers, role, timestamps, and basic OAuth profile data.</li>
        <li>Content/activity: topics, comments, drawings, votes, saves, moderation actions, abuse reports.</li>
        <li>Device/usage: IP, user agent, referrer, app events for security/operations.</li>
        <li>Location you provide in posts/drawings (we do not auto-collect precise GPS).</li>
        <li>Cookies/local storage for sessions, preferences, consent.</li>
        <li>Analytics/ads (with consent): Google Analytics and Google AdSense.</li>
      </ul>

      <h3>How we use information</h3>
      <ul style={{ color: '#374151', paddingLeft: 20 }}>
        <li>Operate and improve the service; authenticate users; prevent fraud/abuse.</li>
        <li>Provide safety/moderation and enforce Terms.</li>
        <li>Analytics with consent; advertising via AdSense with consent for personalization.</li>
        <li>Transactional communications (account emails).</li>
        <li>Legal compliance and responses to lawful requests.</li>
      </ul>

      <h3>Sharing</h3>
      <ul style={{ color: '#374151', paddingLeft: 20 }}>
        <li>Service providers (hosting, storage, auth, email, analytics, ads).</li>
        <li>Legal/safety requests when required.</li>
        <li>Business transfers if the service changes ownership.</li>
      </ul>

      <h3>Consent, ads, and GPC</h3>
      <p style={{ color: '#4b5563' }}>
        In regions requiring consent, analytics and personalized ads stay off until you opt in. We honor Global Privacy Control (GPC) and “Do Not Sell/Share” choices by disabling targeted ads/analytics where applicable.
      </p>

      <h3>Retention & deletion</h3>
      <ul style={{ color: '#374151', paddingLeft: 20 }}>
        <li>Deleting your account removes your profile/sign-in; conversation content may be anonymized to preserve context.</li>
        <li>Minimal identifiers may be retained in a restricted legal/safety record as required.</li>
        <li>Operational logs kept for limited periods for security/abuse investigations.</li>
      </ul>

      <h3>Your rights</h3>
      <p style={{ color: '#4b5563' }}>
        You may request access, correction, deletion, export, object/restrict processing (where applicable), and opt out of “sale/share” for targeted ads. Contact <a href="mailto:support@loconvo.com" style={{ color: '#2563eb' }}>support@loconvo.com</a>.
      </p>

      <h3>Security</h3>
      <p style={{ color: '#4b5563' }}>
        Data is encrypted in transit; access is limited to authorized personnel. To report a security issue, email <a href="mailto:support@loconvo.com" style={{ color: '#2563eb' }}>support@loconvo.com</a>.
      </p>

      <h3>Children</h3>
      <p style={{ color: '#4b5563' }}>LoConvo is not directed to children under 13.</p>

      <h3>Updates</h3>
      <p style={{ color: '#4b5563' }}>We may update this notice; continued use after changes means you accept the updated notice.</p>

      <p style={{ color: '#4b5563', marginTop: 16 }}>
        Full details are in the repository Privacy Notice. Contact us at <a href="mailto:support@loconvo.com" style={{ color: '#2563eb' }}>support@loconvo.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPage;
